/* eslint-disable @nx/enforce-module-boundaries */
import {CmsPDPMap as bmlMap} from 'apps/pdp/src/config/markets/us/cms-map';

export const environment = {
  production: true,
  bmlMap,
  featureImport: () => import('libs/pdp-main/src/lib/pdp-main.module')
};
